export default {
  button: {
    en: 'Login',
  },
}
